module.exports = __webpack_public_path__ + "static/media/Page_42_Fashion-Portfolio.94518428.jpg";